var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNotEmpty, IsString } from 'class-validator';
export var VendorLoginValidationMessageKey;
(function (VendorLoginValidationMessageKey) {
    VendorLoginValidationMessageKey["REQUIRED_COMPANY_NAME"] = "REQUIRED_COMPANY_NAME";
    VendorLoginValidationMessageKey["REQUIRED_USERNAME"] = "REQUIRED_USERNAME";
    VendorLoginValidationMessageKey["REQUIRED_PASSWORD"] = "REQUIRED_PASSWORD";
})(VendorLoginValidationMessageKey || (VendorLoginValidationMessageKey = {}));
export class VendorLoginDto {
}
__decorate([
    IsString({ message: VendorLoginValidationMessageKey.REQUIRED_COMPANY_NAME }),
    IsNotEmpty({
        message: VendorLoginValidationMessageKey.REQUIRED_COMPANY_NAME,
    }),
    __metadata("design:type", String)
], VendorLoginDto.prototype, "companyName", void 0);
__decorate([
    IsString({ message: VendorLoginValidationMessageKey.REQUIRED_USERNAME }),
    IsNotEmpty({
        message: VendorLoginValidationMessageKey.REQUIRED_USERNAME,
    }),
    __metadata("design:type", String)
], VendorLoginDto.prototype, "username", void 0);
__decorate([
    IsString({ message: VendorLoginValidationMessageKey.REQUIRED_PASSWORD }),
    IsNotEmpty({
        message: VendorLoginValidationMessageKey.REQUIRED_PASSWORD,
    }),
    __metadata("design:type", String)
], VendorLoginDto.prototype, "password", void 0);
